import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 14 14",
  stroke: "white"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M2.32052 7C2.06973 6.96348 1.87073 6.90271 1.69565 6.80162C1.40814 6.63561 1.16938 6.39683 1.00339 6.10928C0.75 5.67035 0.75 5.08108 0.75 3.90252C0.75 2.72396 0.75 2.13468 1.00339 1.69576C1.16938 1.40821 1.40814 1.16943 1.69565 1.00341C2.13453 0.75 2.72374 0.75 3.90216 0.75C5.08059 0.75 5.6698 0.75 6.10868 1.00341C6.39619 1.16943 6.63495 1.40821 6.80094 1.69576C6.90202 1.87085 6.96278 2.06988 6.9993 2.32069",
      fill: "none",
      "stroke-width": "1.2",
      "stroke-linecap": "round"
    }, null, -1),
    _createElementVNode("path", {
      d: "M5.45088 10.125C5.1975 10.0886 4.99688 10.0277 4.82053 9.92584C4.53305 9.75985 4.29433 9.5211 4.12835 9.23359C3.875 8.79472 3.875 8.20552 3.875 7.02711C3.875 5.84871 3.875 5.2595 4.12835 4.82063C4.29433 4.53312 4.53305 4.29438 4.82053 4.12838C5.25935 3.875 5.84848 3.875 7.02676 3.875C8.20503 3.875 8.79417 3.875 9.23299 4.12838C9.52046 4.29438 9.75919 4.53312 9.92516 4.82063C10.027 4.997 10.0879 5.19765 10.1243 5.45106",
      fill: "none",
      "stroke-width": "1.2",
      "stroke-linecap": "round"
    }, null, -1),
    _createElementVNode("path", {
      d: "M7 10.125C7 8.95673 7 8.3726 7.25117 7.9375C7.41572 7.65246 7.65239 7.41577 7.9374 7.2512C8.37244 7 8.95651 7 10.1247 7C11.2928 7 11.8769 7 12.3119 7.2512C12.5969 7.41577 12.8336 7.65246 12.9981 7.9375C13.2493 8.3726 13.2493 8.95673 13.2493 10.125C13.2493 11.2933 13.2493 11.8774 12.9981 12.3125C12.8336 12.5975 12.5969 12.8342 12.3119 12.9988C11.8769 13.25 11.2928 13.25 10.1247 13.25C8.95651 13.25 8.37244 13.25 7.9374 12.9988C7.65239 12.8342 7.41572 12.5975 7.25117 12.3125C7 11.8774 7 11.2933 7 10.125Z",
      fill: "none",
      "stroke-width": "1.2"
    }, null, -1)
  ]))]))
}
export default { render: render }